import React from 'react';
import { BackTestingChart as BackTestingChartContainer } from '../../../shared/components/BacktestingChart';
import './BacktestingChart.scss';

export const BackTestingChart: React.FC = () => (
  <div className="backtesting-chart">
    <BackTestingChartContainer />
  </div>
);
